import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const CustomerActivityInput = () => {
  const { activityId = '' } = useParams();
  const decodedId = activityId ? atob(activityId) : activityId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'customerActivity';

  useEffect(() => {
    if (activityId) {
      setIsEditing(true);
      fetchActivityDetails();
    }
  }, [activityId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchActivityDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customerActivity}${id}/`, { headers });
      const d = response.data;
      setFormData({
        ...d,
        customer: d.customer?.id ?? d.customer,
        activity_type: d.activity_type?.id ?? d.activity_type,
        assigned_to: d.assigned_to?.id ?? d.assigned_to,
        created_by: d.created_by?.id ?? d.created_by,
      });
    } catch (error) {
      console.error('Error fetching activity details:', error);
    }
  };

  const activityFields = [
    { name: 'subject', label: 'Subject', type: 'text' },
    {
      name: 'customer', label: 'Customer', type: 'async-select',
      endpoint: API_ROUTES.customer,
      getOptionLabel: (c) => c.name,
    },
    {
      name: 'activity_type', label: 'Activity Type', type: 'async-select',
      endpoint: API_ROUTES.customerActivityType,
      getOptionLabel: (t) => t.name,
    },
    { name: 'scheduled_date', label: 'Scheduled Date & Time', type: 'datetime-local' },
    { name: 'location', label: 'Location', type: 'text' },
    { name: 'duration_minutes', label: 'Duration (minutes)', type: 'number' },
    { name: 'description', label: 'Description / Notes', type: 'textarea' },
    {
      name: 'outcome', label: 'Outcome', type: 'select',
      options: [
        { value: '', label: '— Select Outcome —' },
        { value: 'positive', label: 'Positive' },
        { value: 'neutral', label: 'Neutral' },
        { value: 'negative', label: 'Negative' },
        { value: 'no_answer', label: 'No Answer' },
        { value: 'pending', label: 'Pending' },
      ],
    },
    { name: 'outcome_notes', label: 'Outcome Notes', type: 'textarea' },
    { name: 'follow_up_required', label: 'Follow-up Required', type: 'checkbox' },
    { name: 'follow_up_date', label: 'Follow-up Date', type: 'date', dateConstraint: 'future' },
    { name: 'is_completed', label: 'Completed', type: 'checkbox' },
    { name: 'completed_at', label: 'Completed At', type: 'datetime-local', dateConstraint: 'past' },
    {
      name: 'assigned_to', label: 'Assigned To', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    {
      name: 'created_by', label: 'Created By', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Customer Activity' : 'Create Customer Activity'}</h1>
      <FormComponent fields={activityFields} initialFormData={formData} route={route} cancelPath="/customer/activity/list" />
    </div>
  );
};

export default CustomerActivityInput;
